let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dhv29")).then(() => parcelRequire('3MZo0'));